class LeproCartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('lepro-mini-cart')

      $(this).addClass('loading')

      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('lepro-cart-remove-button', LeproCartRemoveButton);

// 迷你购物车
class LeproMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-drawer')
    
    this.updateCartInfo()

    this.bindEvent()
    if (this.cart.firstLoad) {
      this.initCoponCodes()
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // 绑定事件
  bindEvent() {
    const _that = this

    const debouncedUpdate = this.debounce(function(itemIndex, quantityNum, event) {
      _that.enableLoading(event);
      _that.updateQuantity(itemIndex, quantityNum, event);
    }, 500);

    $(this).on('click', '.apply-btn', function (event) {
      // fetch('/collections/ai/products.json?limit=1')
      //   .then(response => response.json())
      //   .then(data => {
      //   });

      let coupon = $(this).siblings('input[name="coupon"]').val()
      const defaultCoupon = $(this).parents('.coupon-code').find('.coupon-tags').attr('data-coupons')
      if (coupon) {
        if (defaultCoupon) {
          coupon = defaultCoupon + ',' + coupon
        }
        $(this).attr('disabled', true)
        _that.enableLoading(event)
        _that.apply(coupon)
      }
    })

    $(this).on('blur', '.quantity-num', function (event) {
      const newquantityNum = parseFloat($(this).val())
      const quantityNum = parseFloat($(this).attr('data-quantity'))

      if (newquantityNum != quantityNum) {
        const itemIndex = $(this).parents('.item').attr('data-index')

        debouncedUpdate(itemIndex, newquantityNum, event);
      }
    })

    $(this).on('click', '.open-btn', function (event) {
      const btnName = $(this).attr('name')
      let quantityNum = parseFloat($(this).siblings('.quantity-num').val())
      const itemIndex = $(this).parents('.item').attr('data-index')

      if (btnName == 'plus') {
        quantityNum += 1
      } else {
        quantityNum -= 1
      }
      $(this).siblings('.quantity-num').val(quantityNum)

      debouncedUpdate(itemIndex, quantityNum, event);
    })

    $(this).on('click', '.delete-coupon', function (event) {
      // console.log('******* click delete')
      const coupons = $(this).parents('.coupon-tags').attr('data-coupons')
      const currentCoupon = $(this).attr('data-coupon')
      let arr = coupons.split(',')
      arr = arr.filter(item => item != currentCoupon)
      let result = arr.join(',')
      if (coupons) {
        _that.enableLoading(event)
        _that.apply(result)
      }
    })

    $(this).on('click', '.down-up-btn', function () {
      const hideNode = $(_that).find('.mini-cart__footer .price-visibility-hide')
      hideNode.slideToggle(300)
      $(this).toggleClass('active')
    })

    $(this).on('click', '.checkout-btn', function () {
      window.location.href = '/checkout'
    })
  }

  // 获取 折扣码 列表
  initCoponCodes(newHtmlText) {
    fetch('/cart.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => response.json())
      .then((response) => {
        let codeNode = ''
        const codesArr = []
        const codes = response.discount_codes

        if (codes && codes.length > 0) {
          codes.forEach(code => {
            if (code.applicable) {
              codesArr.push(code.code)
              codeNode += `<span class="tag flex align-items-center">${code.code} <span class="delete-coupon flex align-items-center justify-center cursor-pointer" data-coupon="${code.code}"><svg class="le_icon" viewBox="0 0 1024 1024" width="28" height="28"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_close"></use></svg></span></span>`
            }
          })
        }

        if (response.token.split('key').length === 2) {
          window.cartToken = response.token
        }

        this.updateMiniCartNode(codeNode, codesArr, newHtmlText)
      })
      .catch((e) => {
        this.updateMiniCartNode('', '', newHtmlText)
      })
  }

  // 拿到迷你购物车的 dom，简单处理一下，然后加载都页面上
  updateMiniCartNode(codeNode = '', codesArr = [], newHtmlText = '') {
    if (newHtmlText) {
      let couponHtml = newHtmlText
      if (codeNode) {
        const regex = /(<[^>]+class="coupon-tags flex flex-wrap"[^>]*>)([\s\S]*?)(<\/[^>]+>)/i;
        couponHtml = newHtmlText.replace(regex, (match, startTag, oldContent, endTag) => {
          return `${startTag}${codeNode}${endTag}`;
        });

        const regexCoupons = /(<[^>]+class="[^"]*coupon-tags flex flex-wrap[^"]*"[^>]*>)/i;
        couponHtml = couponHtml.replace(regexCoupons, (match) => {
          if (match.includes('data-coupons=')) {
            return match.replace(/data-coupons="[^"]*"/, `data-coupons="${codesArr.join(',')}"`);
          } else {
            return match.replace('>', ` data-coupons="${codesArr.join(',')}">`);
          }
        })
      }

      // const couponCodeNode = $(newHtmlText)
      // if (codeNode) {
      //   couponCodeNode.find('.coupon-code .coupon-tags').html(codeNode)
      //   couponCodeNode.find('.coupon-code .coupon-tags').attr('data-coupons', codesArr.join(','))
      // }
      // const html = new DOMParser().parseFromString(couponCodeNode[0].outerHTML, 'text/html');
      const html = new DOMParser().parseFromString(couponHtml, 'text/html');
      const selectors = ['lepro-mini-cart'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    } else {
      if (codeNode) {
        $(this).find('.coupon-code .coupon-tags').html(codeNode)
        $(this).find('.coupon-code .coupon-tags').attr('data-coupons', codesArr.join(','))
      }
    }
  }

  // 设置购物车数量
  setCartNum(quantity, isCount = false) {
    if (isCount) {
      const currentQ = parseFloat($('#cart-icon-bubble .cart-count-bubble span').text() || 0)
      quantity += currentQ
    }
    if (quantity < 1) {
      $('#cart-icon-bubble .cart-count-bubble').hide()
    } else {
      if ($('#cart-icon-bubble .cart-count-bubble').length < 1) {
        $('#cart-icon-bubble').append(`<div class="cart-count-bubble"><span aria-hidden="true"></span></div>`)
      }
    }
    if (quantity > 99) {
      quantity = '99+'
      $('#cart-icon-bubble .cart-count-bubble').addClass('more-count')
    } else {
      $('#cart-icon-bubble .cart-count-bubble').removeClass('more-count')
    }
    $('#cart-icon-bubble .cart-count-bubble span').text(quantity)
  }

  // 更新迷你购物车的 dom
  onCartUpdate() {
    this.cart.firstLoad = false
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        this.initCoponCodes(responseText)
      })
      .catch((e) => {
      });
  }

  // 使用折扣码
  apply(coupon) {
    const formData = new URLSearchParams()

    formData.append('discount', coupon)
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    }).then((response) => response.json())
      .then((responseJson) => {
        this.onCartUpdate()
      })
      .catch((e) => {
      });
  }

  // 更新加购数量
  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(event);

    const body = JSON.stringify({
      line,
      quantity,
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        this.setCartNum(parsedState.item_count)
        this.onCartUpdate()
      })
      .catch((error) => {
      })
      .finally(() => {
        // this.disableLoading(line);
      });

    this.cartItems = document.querySelector('cart-items')
    if (this.cartItems) {
      $(`#CartItem-${line}`).find('.quantity__input').val(quantity)
      this.cartItems.updateQuantity(line, quantity, event)
    }
  }

  enableLoading(event) {
    $(event.currentTarget).parents('.lepro-mini-cart-section').find('#mini-cart-loading-overlay').show()
    $(event.currentTarget).parents('.lepro-mini-cart-section').find('.mini-cart-check .price-info .dot').addClass('loading')
  }

  // 判断是否有悬浮的购物车信息，如果有更新悬浮购物车信息
  updateCartInfo() {
    window.ShopifyConstant.updateFixedCartInfo()
  }
}

customElements.define('lepro-mini-cart', LeproMiniCart)

// 迷你购物车中的加购按钮
class LeproAlsoLikeCartBtn extends LeAddCartBtn {
  constructor() {
    super();
  }

  /** 重写基础组件中添加购物车请求方法 */
  addCartRequest(e, config) {
    const buttonNode = this.querySelector('button')
    const cartItems = this.closest('lepro-mini-cart')
    fetch(`${routes.cart_add_url}`, config)
      .then(async response => {
        const cartData = await response.json()
        if (!response.ok || cartData.status) return cartData
        try {
          await this.setDiscountCode()
        } catch (error) {
          window.ShopifyConstant.reportCartDiscountError(error)
        }
        return cartData
      }).then((response) => {
        if (response.status) return
        cartItems.setCartNum(response.quantity, true)
        cartItems.onCartUpdate()
      })
      .catch((error) => {
      }).finally(() => {
        buttonNode.classList.remove('loading')
        buttonNode.removeAttribute('disabled')
      })
  }
}
customElements.define('lepro-also-like-cart-btn', LeproAlsoLikeCartBtn)
